import { motion } from 'framer-motion';
import SEOHead from '../components/SEOHead';

const steps = [
  {
    number: '01',
    title: 'Create one or more business profiles',
    body: 'Add the legal name, trade name, GSTIN, state, city, contact details, and logo for each business. The app keeps an active business selected so every invoice, report, party, and item stays in the right book.',
  },
  {
    number: '02',
    title: 'Build your master data',
    body: 'Add customers and suppliers with GSTIN, billing address, shipping address, opening balance, credit limit, and contact details. Add products and services with HSN or SAC, GST rate, unit, pricing, and stock thresholds.',
  },
  {
    number: '03',
    title: 'Create business documents',
    body: 'Generate sales and purchase invoices, quotations, proforma invoices, cash memos, credit notes, debit notes, and delivery challans. Line items calculate taxable value, CGST, SGST, IGST, discounts, totals, and balances.',
  },
  {
    number: '04',
    title: 'Record payments and close the month',
    body: 'Capture payments in, payments out, and journal entries in the ledger. Review outstanding invoices, stock alerts, GST collected, sales summaries, purchase summaries, profit and loss, and customer performance.',
  },
  {
    number: '05',
    title: 'Handle GST compliance work',
    body: 'Move from invoice data into e-invoice IRN records, e-way bills for goods movement, and GST report views for outward supplies, inward supplies, and net liability.',
  },
];

const HowItWorks = () => (
  <>
    <SEOHead
      title="How it works"
      description="See how Varikanakku turns business profiles, parties, items, invoices, ledgers, e-invoices, e-way bills, and GST reports into one connected billbook workflow."
      url="https://varikanakku.com/how-it-works"
    />

    <div className="border-b border-slate-200 bg-white">
      <div className="container-custom py-16 lg:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <p className="eyebrow">How it works</p>
          <h1 className="section-title mt-2">From first business profile to month-end GST review</h1>
          <p className="mt-4 text-lg text-surface-body">
            Varikanakku follows the way a real billbook grows: business setup,
            customer and item master data, GST documents, payment entries, then
            reports your accountant can work from.
          </p>
        </div>
      </div>
    </div>

    <div className="bg-surface-page py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-4xl space-y-6">
          {steps.map(({ number, title, body }, i) => (
            <motion.div
              key={number}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              className="flex gap-6 rounded-lg border border-slate-200 bg-white p-6 shadow-card sm:p-8"
            >
              <span className="shrink-0 text-3xl font-bold text-primary-300 sm:text-4xl">{number}</span>
              <div>
                <h2 className="text-xl font-semibold text-surface-ink">{title}</h2>
                <p className="mt-3 leading-relaxed text-surface-body">{body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </>
);

export default HowItWorks;
